<template>
    <!-- ai智慧管理 -->
    <div class="box">
        <div class="header" v-if="!isMobile">
            <div class="header-left">
                <div class="header-left-title">
                    {{ config.headerTitle }}
                </div>
                <div class="header-left-info">
                    {{ config.headerDesc }}
                </div>
            </div>
            <div class="header-right">
                <img :src="config.headerImg" alt="">
            </div>
        </div>

        <Nav v-else :headerTitle="config.headerTitle" :headerDesc="config.headerDesc" :headerImg="config.headerImg"></Nav>

        <div class="content">
            <div v-for="item in config.content" :key="item.title" class="content-item">
                <div class="title">{{ item.title }}</div>
                <div class="info">{{ item.info }}</div>
                <div class="img">
                    <img :src="item.src" alt="">
                </div>
            </div>
            <div class="bottom">
                <div class="title">{{ config.bottom.title }}</div>
                <div class="imgs">
                    <img v-for="item in config.bottom.imgs" :key="item" :src="item" alt="">
                </div>
            </div>
        </div>
        <appService></appService>
    </div>
</template>

<script>
import { config } from './config'
import pageHeader from '../common/page_header'
import enoPagination from '../common/eno_pagination'
import appService from '../common/appService.vue'
import Nav from '../common/components/nav.vue'
export default {
    name: 'aaa',
    components: { pageHeader, enoPagination, appService, Nav },
    data() {
        return {
            config: config,
        };
    },
    computed: {
        isMobile() {
            return this.$store.getters.isMobile;
        }
    },
    watch: {
    },
    methods: {

    },
};
</script>

<style scoped lang="less">
.header {
    height: 500px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    background-color: #EAEAF2;

    .header-left {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 68px;

        .header-left-title {
            font-size: @fontSize40;

        }

        .header-left-info {
            margin-top: 30px;
            font-size: @fontSize16;
        }
    }

    .header-right {
        img {
            width: 100%;
        }
    }

}

.content {
    padding: 0 143px;

    .content-item {
        margin: 80px 0;
        cursor: pointer;
    }

}

.title {
    font-size: 24px;

}

.info {
    margin-top: 20px;
    font-size: @fontSize16;

}

.img {
    width: 100%;
    text-align: center;

    img {
        margin-top: 80px;
    }
}



.imgs {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 40px;
}


@media @mobile {
    .header {
        display: flex;
        height: auto;
        flex-direction: column;
        box-sizing: border-box;

        .header-left {
            padding: 0;
            background-color: #2E2E38;
            color: #FFFFFF;
            padding: 140px 15px;

            &-title {
                font-size: 24px;
                text-align: left;
                color: #FFF100;
            }

            &-info {
                font-size: 14px;
                line-height: 24px;
                margin-top: 15px;
                text-align: left;
            }
        }
    }

    .content {
        padding: 0 20px;

        .imgs {
            display: flex;
            flex-direction: column;
        }
    }
}
</style>
